import { FC, memo } from "react";
import Contact from "@/assets/images/contact.svg";
import { useTranslation } from "react-i18next";

export const AppVersion: FC = memo(() => {
  const { t } = useTranslation();
  return (
    <div className="absolute bottom-4 right-4 flex flex-row justify-end rounded-[2px] bg-amber-400 bg-white px-1 py-0.5 opacity-75">
      <p className="text-xs text-gray-500">{__APP_VERSION__}</p>
      <a
        href={`mailto:consiteseeker@hitachi-kenki.com?subject=${t("contact_us_subject")}`}
        className={"mx-2 flex flex-1"}
      >
        <img src={Contact} className={"h-4 w-4"} />
        <p className={"text-nowrap pr-3 text-xs"}>{t("contact_us")}</p>
      </a>
    </div>
  );
});
